module.exports = __webpack_public_path__ + "static/img/jylhIcon.56ea4835.png";